export default {
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '15px'
}
